import React, { Component } from 'react'
import Modal from 'react-modal';
import { Button } from 'components/Buttons'
import { connect } from 'react-redux'
import { identity } from 'lodash'
import { getAccessoriesVM } from 'state/viewModels'
import * as actions from 'ducks/modules/customize'
import Price from 'components/Price'
import PaintSwatch from './PaintSwatch'
import AccessoriesGrid from './AccessoriesGrid'
import "./AccessoriesView.css"
import { trackedClickEvent } from '../util/analytics';

export class AccessoriesView extends Component {
  constructor() {
    super();
    this.state = { 
      colorFilters: [],
      accessoryImg: '',
      accessoryId: 0,
      accessoryLabel: '',
      accessoryType: '',
      accessoryPrice: '',
      accessoriesZoomModalIsOpen: false,
    }
    this.openZoomModal = this.openZoomModal.bind(this);
    this.closeZoomModal = this.closeZoomModal.bind(this);
  }

  openZoomModal(event, accessoryImg, accessoryId, accessoryLabel, accessoryType, accessoryPrice) {
    event.stopPropagation();
    this.setState({
      accessoryImg: accessoryImg,
      accessoryId: accessoryId,
      accessoryLabel: accessoryLabel,
      accessoryType: accessoryType,
      accessoryPrice: accessoryPrice,
      accessoriesZoomModalIsOpen: true,
    });
  }

  closeZoomModal() {
    this.setState({accessoriesZoomModalIsOpen: false});
  }

  setColorFilters(color) {
    let newColorFilters = this.state.colorFilters;
    if (!color)
    {
      newColorFilters = [];
    }
    else
    {
      const index = newColorFilters.indexOf(color);
      if(index > -1)
      {
        newColorFilters.splice(index, 1);
      }
      else
      {
        newColorFilters.push(color);
      }
    }
    this.setState({ colorFilters: newColorFilters });
  }

  render = () => (
    <div>
      <div className="accessories-filter">
        <div className="choose-accessory-label">Choose {this.props.accessoryType.replace('shaftBand', 'shaft band')}</div>
        <div className="side-radio">
          <label className="show-all">
            <div className={(!!this.state.colorFilters && this.state.colorFilters.length === 0 ? 'option-selected ' : '') + "radio-target"} ></div>
            <input type="radio" name="accessories-filter" 
              onClick={() => this.setColorFilters(null)}
            />
            <span>Show All</span>
          </label>
        </div>
        <div className="side-radio">
          <label className="filter-by-color">
            <div className={(!!this.state.colorFilters && this.state.colorFilters.length > 0 ? 'option-selected ' : '') + "radio-target"} ></div>
            <input type="radio" name="accessories-filter" 
            />
              <span className="filter-by-color-text" >Filter by Color:</span>
              <span className="filter-by-color-swatches">
                {this.props.colorFilters.filter(color => {
                    switch(this.props.accessoryType) {
                      case 'grip':
                        return this.props.grip.options.some(gripOption => gripOption.color === color.tagName)
                      case 'shaftBand':
                        return this.props.shaftBand.options.some(shaftBandOption => shaftBandOption.color === color.tagName)
                      case 'headCover':
                        return this.props.headCover.options.some(headCoverOption => headCoverOption.color === color.tagName)
                      default:
                        return false;
                    }
                  })
                  .map(color => (
                    <PaintSwatch 
                      key={color.label} 
                      paint={color} 
                      selected={this.state.colorFilters.filter(colorFilter => colorFilter.label === color.label).length > 0}
                      onClick={trackedClickEvent("Accessories Filter : " + color.label, () => {
                        //color.selected = !color.selected;
                        this.setColorFilters(color);
                        }
                      )} 
                    />
                ))}
              </span>
          </label>
        </div>
      </div>
      {this.props.accessoryType === 'grip'&& 
        <AccessoriesGrid 
          accessories={this.props.grip} 
          colorFilters={this.state.colorFilters} 
          accessoryType={this.props.accessoryType}  
          onSelectAccessory={this.props.onFieldChange}
          closeModal={this.props.closeModal}
          onZoomAccessory={this.openZoomModal}
          closeZoomModal={this.closeZoomModal}
        />
      }
          
      {this.props.accessoryType === 'shaftBand' && 
        <AccessoriesGrid 
          accessories={this.props.shaftBand} 
          colorFilters={this.state.colorFilters} 
          accessoryType={this.props.accessoryType} 
          onSelectAccessory={this.props.onFieldChange}
          closeModal={this.props.closeModal}
          onZoomAccessory={this.openZoomModal}
          closeZoomModal={this.closeZoomModal}
        />
      }
      
      {this.props.accessoryType === 'headCover' && 
        <AccessoriesGrid 
          accessories={this.props.headCover} 
          colorFilters={this.state.colorFilters} 
          accessoryType={this.props.accessoryType} 
          onSelectAccessory={this.props.onFieldChange}
          closeModal={this.props.closeModal}
          onZoomAccessory={this.openZoomModal}
          closeZoomModal={this.closeZoomModal}
        />
      }
      <Modal className="customizer accessories-zoom-modal modal-popup" overlayClassName="accessories-zoom-modal modal-overlay"
          isOpen={this.state.accessoriesZoomModalIsOpen}
          onRequestClose={this.closeZoomModal}
          contentLabel="Accessories Zoom Modal"
        > 
        <div className="accessories-zoom-modal-content">
          <div className="close-modal" onClick={this.closeZoomModal}>X</div>
          <br/>
          <div className="accessory-zoom-content">
            <div className="accessory-img">
              <img src={this.state.accessoryImg} alt={this.state.accessoryLabel} />
            </div>
            <div className="accessory-title">{this.state.accessoryLabel}</div>
            <div className="accessory-price"><Price value={this.state.accessoryPrice} /></div>
            <div className="accessory-select">
              <Button onClick={() => {
                this.props.onFieldChange(this.state.accessoryType, this.state.accessoryId);
                this.closeZoomModal();
                if (this.props.closeModal) {
                  this.props.closeModal();
                }
              }}>Select</Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

AccessoriesView.defaultProps = {
  onFieldChange: identity,
};

const mapStateToProps = (state, ownProps) => {
  return { 
    ...getAccessoriesVM(state.customize)
  }
}

const mapDispatchToProps = {
  onFieldChange: actions.selectField,
}

export default connect(mapStateToProps, mapDispatchToProps)(AccessoriesView);